<div class="project-configuration" data-automation-id="project-configuration-container">
    <div class="header-bar" data-automation-id="project-configuration-header'">
        <button type="button" data-automation-id="project-configuration-save-button" class="primary-button"
            (click)="saveChanges()" *ngIf="hasAddEditPermission" [disabled]="isDisabled()">Save</button>
        <button type="button" data-automation-id="project-configuration-discard-changes-button" class="secondary-button"
            (click)="discardChanges()" *ngIf="hasAddEditPermission" [disabled]="isDisabled()">Discard Changes</button>
        <!-- <button type="button" class="help-button" data-automation-id="project-configuration-help-button'"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button> -->
    </div>
    <div class="header-cell">
        <span>General</span>
    </div>
    <div class="modal-row content-panel" [resBusySpinner]="isBusy" [message]="isBusyMessage">
        <res-custom-checkbox class="modal-row-column-auto" data-automation-id="project-configuration-conflict-check-complete-checkbox"
            content="Conflict Check Complete" [(ngModel)]="isConflictCheckComplete" (ngModelChange)="onCheckboxChanged()" [disabled]="!hasAddEditPermission">
        </res-custom-checkbox>
        <label class="last-updated-label modal-row-column-auto" [hidden]="isDateLabelHidden" data-automation-id="project-configuration-last-changed-label">(Last changed to checked: <span class="label-date-text">{{lastCheckedDateTime | date:'yyyy-MM-dd HH:mm:ss'}}</span>)</label>
    </div>
</div>